// School scoping helper — iOS stores schoolId as uppercase UUID, web may store lowercase.
// Always compare case-insensitively.
export const schoolMatches = (a, b) =>
  !!a && !!b && String(a).toLowerCase() === String(b).toLowerCase();

// Filter docs to a school. If sid is falsy, returns docs unchanged (super admin "all" view).
export const scopeBySchool = (docs, sid) =>
  sid ? docs.filter(d => schoolMatches(d.schoolId, sid)) : docs;

// For admin views: adminData present but no schoolId -> show nothing (don't leak all schools).
export const scopeForAdmin = (docs, adminData) =>
  adminData ? scopeBySchool(docs, adminData.schoolId) : docs;

// All school ids an admin doc may reference (schoolId or schoolIds array), lowercased.
export const adminSchoolIds = (adminData) => {
  if (!adminData) return [];
  const ids = [adminData.schoolId, ...(adminData.schoolIds || [])].filter(Boolean).map(String);
  return [...new Set(ids.map(i => i.toLowerCase()))];
};

// True if the doc's schoolId matches one of the given ids (case-insensitive).
// Empty ids list -> false (don't leak cross-school data).
export const docInScope = (docSchoolId, ids) =>
  !!docSchoolId && (ids || []).some(id => schoolMatches(docSchoolId, id));
